export const ANALYTICS = {
  TOOLTIP: {
    AVG_RESPONSE_TIME:
      'The average time took for the agents to send the first message to the user after accepting the chat request',
    SELECT_TIME: 'Showing results for the selected duration',
    ENGAGEMENTS:
      'The number of engagement indicates at least one message exchange between the visitor and the widget',
    KNOWN_ACCOUNT_VISITS:
      'The accounts which Insent was able to resolve as a Company name or a domain',
    AVG_RESPONSE_TIME_VISIT:
      'The average time took for the agents to send the first message to the user after accepting the chat request, in a single visit',
  },
};
export const BUILD_CONVERSATION = {
  ALERTS: {
    REDIRECT_CONDITION: "Only one of 'Live Chat, Go to path, Buttons' allowed in a path",
    ALERT_CONDITION: 'Only one alert is allowed in a path',
    REMOVE_PATH: 'Are you sure you want to remove this path?',
    DELETE_CONVERSATION: 'Are you sure you want to delete this conversation?',
    CLONE_CONVERSATION: 'Are you sure you want to clone this conversation?',
    CONVERSATION_STATUS_CHANGE: 'Conversation status changed successfully',
    DELETE_CONVERSATION_SUCCESS: 'Conversation deleted successfully',
    CLONE_CONVERSATION_SUCCESS: 'Conversation cloned successfully',
    SAVE_CONVERSATION_SUCCESS: 'Conversation saved successfully',
    SAVE_AUDIENCE_SUCCESS: 'Audience saved successfully',
    FIRST_PATH_NO_CHANGE: 'The first path cannot be re-ordered or deleted',
    NEW_FIELD_CREATED_SUCCESS: 'New field created successfully',
    ERROR_IN_PATHS: 'Please fix all the errors, to save the conversation flow',
    ERROR_IN_AUDIENCE: 'Missing required fields',
    FORM_NOT_SELECTED: 'Please select a form from the website',
    CONVERSATION_NAME_SUCCESS: 'Conversation name updated successfully',
  },
};
export const CHAT = {
  ALERTS: {
    BOOK_MEETING_START: 'Do you want to start the book meeting flow?',
    AGENTS_ADDED_SUCCESS: 'Added agents to the conversation successfully!',
    REMOVE_AGENT_SUCCESS: 'Removed agent from the conversation successfully!',
    AVAILABLE_STATUS_CHANGE_SUCCESS: 'Updated the availability status successfully!',
    CLOSE_CONVERSATIONS_SUCCESS: 'Closed all the selected conversations successfully!',
    COMPLETE_PROFILE: 'Please complete the profile, to go online',
  },
};
export const CONFIGURATIONS = {
  TOOLTIP: {
    SHOW_WIDGET: 'Toggle the visibility of Insent widget on your website',
    PERSONALIZATION: 'Toggle the personalization of greeting message',
  },
  ALERTS: {
    UPDATE_RULE_SUCCESS: 'Updated the rule successfully',
    DELETE_RULE_SUCCESS: 'Deleted the rule successfully',
    UPDATE_RULE_STATUS_SUCCESS: 'Updated the rule status successfully',
    WIDGET_STATUS: 'Status of the widget updated successfully',
    VISITOR_NAME_STATUS: 'Status of the visitor name updated successfully',
    SAVE_BOT_SETTINGS_SUCCESS: 'Updated the widget settings successfully',
    ADD_FIELD_FUNCTION:
      'Ability to customize and map more fields will be added very soon in an upcoming release',
  },
};
export const CONVERSATIONS = {
  ALERTS: {
    NEW_CONVERSATION_SUCCESS: 'Created new conversation successfully',
  },
};
export const VERIFY_EMAIL = {
  ALERTS: {
    VERIFY_EMAIL_SUCCESS: 'Email verified successfully!',
  },
};
export const FORGOT_PASSWORD = {
  ALERTS: {
    PASSWORD_CHANGE_SUCCESS: 'Password change successfully!',
  },
};
export const HUBSPOT_VERIFY = {
  ALERTS: {
    INTEGRATE_HUBSPOT_SUCCESS: 'Hubspot integrated successfully!',
  },
};
export const ZENDESK_VERIFY = {
  ALERTS: {
    INTEGRATE_ZENDESK_SUCCESS: 'Zendesk integrated successfully!',
  },
};
export const MSTEAMS_VERIFY = {
  ALERTS: {
    INTEGRATE_HUBSPOT_SUCCESS: 'MS Team integrated successfully!',
  },
};

export const SLACK_VERIFY = {
  ALERTS: {
    INTEGRATE_SLACK_SUCCESS: 'Slack integrated successfully!',
  },
};

export const CONNECT_TO_HUMAN = {
  PARALLEL_NOTE: `(Don't wait for agent response)`,
  SERIAL_NOTE: '(Wait for agent response )',
};

export const INTEGRATION_PAGE = {
  DESCRIPTION: {
    HUBSPOT:
      'Use your Hubspot lists to build your conversation audience. Sync Insent leads to Hubspot.',
    INTEGRATE_SCRIPT:
      'Integrate the below script in your website domain to make Insent live. The script should be added at the end of the <body> tag of your HTML',
    MARKETO:
      'Use your Marketo lists to build your conversation audience. Sync Insent leads to Marketo. ',
    SALESFORCE: 'Use your Salesforce data to build your conversation audience. ',
    SLACK: "Chat with your website visitors directly from your team's Slack instance.",
    TEAMS: "Chat with your website visitors directly from your team's Microsoft Teams.",
    ZENDESK: 'Enable instant knowledge base search from Insent chat.',
  },
  ALERTS: {
    SAVE_CREDENTIAL_SUCCESS: 'Credential saved successfully!',
    RECONNECTION: 'If you wish to reconnect, please contact Insent support',
    MULTIPLE_MAP:
      'Only one Marketing Automation Platform connection is allowed. Please contact Insent support if you wish to connect additional platforms',
  },
};
export const INVITE = {
  INFO: {
    ACCEPTED_INVITE: 'Successfully accepted the invitation',
    EMAIL_VERIFY_PENDING: 'Email verification of your account is pending. Please check your email',
    CREATE_ACCOUNT_TO_CONTINUE: 'Please create an account to continue',
  },
  ALERTS: {
    INVITE_SUCCESS: 'Invited to project successfully',
  },
};
export const LOGIN_PAGE = {
  ALERTS: {
    NOT_VERIFY: 'Please verify your email to continue',
    LOGIN_SUCCESS: 'Login Success!',
    RESET_PASSWORD: 'We have sent an email to reset your password',
  },
};
export const LOGOUT_PAGE = {
  ALERTS: {
    LOGOUT_SUCCESS: 'Logout Success!',
  },
};
export const PROFILE = {
  ALERTS: {
    SAVE_PROFILE_SUCCESS: 'Updated profile successfully!',
  },
};
export const REGISTER_PAGE = {
  INFO: {
    VERIFY_EMAIL_HEAD: 'A verification link has been sent to your email account',
    VERIFY_EMAIL_DESC:
      'Please click on the link that has just been sent to your email account to verify your email',
  },
  ALERTS: {
    REGISTER_SUCCESS: 'Successfully Register!',
    RESEND_EMAIL_SUCCESS: 'Successfully Resend Email!',
  },
};

export const TEAMS_SUCCESS_PAGE = {
  HEADING: 'You have successfully logged into Insent',
  BODY:
    'Insent bot can alert you when a qualified visitor is on your website and Insent can facilitate live chat with the prospect on your website.',
  KNOW_MORE: 'Know more about how to use Insent with MS Teams',
};

export const TEAM = {
  ALERTS: {
    REMOVE_MEMBER: 'Do you want to remove this member?',
    REMOVE_MEMBER_SUCCESS: 'Removed member successfully!',
    EDIT_MEMBER_SUCCESS: 'Updated member successfully!',
    REMOVE_ROLE: 'Do you want to remove this role?',
    REMOVE_ROLE_SUCCESS: 'Removed role successfully!',
    REMOVE_TEAM: 'Do you want to remove this team?',
    REMOVE_TEAM_SUCCESS: 'Removed team successfully!',
    CLONE_ROLE: 'Do you want to clone this role?',
    CLONE_ROLE_SUCCESS: 'Cloned role successfully!',
    CLONE_TEAM: 'Do you want to clone this team?',
    CLONE_TEAM_SUCCESS: 'Cloned team successfully!',
    UPDATE_ROLE_SUCCESS: 'Updated role successfully!',
    UPDATE_TEAM_SUCCESS: 'Updated team successfully!',
    CREATE_TEAM_SUCCESS: 'Created team successfully!',
    CREATE_ROLE_SUCCESS: 'Created role successfully!',
    ASSIGNED_TEAM_SUCCESS: 'Assigned team successfully!',
    ASSIGNED_ROLE_SUCCESS: 'Assigned role successfully!',
  },
};
export const FORM = {
  ERRORS: {
    ROLE_NAME_REQUIRED: 'Role name is required',
    TEAM_NAME_REQUIRED: 'Team name is required',
    BOT_NAME_REQUIRED: `Bot name is required`,
    PATH_NAME_MIN_LENGTH: 'Path name must be at least 4 characters',
    PATH_NAME_MAX_LENGTH: `Path name must be at most 40 characters`,
    PATH_NAME_REQUIRED: 'Path name is required',
    NAME_MIN_LENGTH: 'Name should contain a minimum of 2 characters',
    NAME_MAX_LENGTH: 'Name must be at most 120 characters',
    COMPANY_MIN_LENGTH: 'Company should contain a minimum of 2 characters',
    COMPANY_MAX_LENGTH: 'Company must be at most 120 characters',
    COMPANY_REQUIRED: 'Company name required',
    DESCRIPTION_MIN_LENGTH: 'Description should contain a minimum of 2 characters',
    DESCRIPTION_MAX_LENGTH: 'Description must be at most 120 characters',
    DESCRIPTION_REQUIRED: 'Description is required',
    VALID_IMAGE_URL: 'Please enter a valid image URL',
    MIN_ONE_FROM_LIST: 'Please select atleast one list from the dropdown',
    VALUE_REQUIRED: 'Please enter a value',
    RULE_NAME_REQUIRED: 'Rule name is required',
    SOURCE_REQUIRED: 'Source is required',
    FIELD_NAME_REQUIRED: 'Insent field name is required',
    FIELD_TYPE_REQUIRED: 'Insent field type is required',
    CLIENT_ID_REQUIRED: 'Client Id is a required field',
    CLIENT_SECRET_REQUIRED: 'Client secret is a required field',
    BASE_URL_REQUIRED: 'Base URL is a required field',
    NAME_REQUIRED: 'Name is required',
    LINKEDIN_URL_VALID: 'Please enter a valid LinkedIn URL',
    LINKEDIN_URL_REQUIRED: 'LinkedIn URL is required',
    TITLE_REQUIRED: 'Title is required',
    TITLE_MIN_LENGTH: 'Title should contain atleast one character',
    TITLE_MAX_LENGTH: 'Title must be at most 50 characters',
    VALID_CALENDAR_LINK: 'Please enter a valid calendar link',
    CALENDAR_LINK_REQUIRED: 'Calender link is required',
    IMAGE_URL_REQUIRED: 'Image is required',
    PHONE_REQUIRED: 'Phone number is required',
    AUDIENCE_NAME_REQUIRED: 'Audience name is required',
  },
};

export const COMMON = {
  SLACK_ALERT: 'Slack alerts will be disabled, if no channels are selected',
  SLACK_NOT_INTEGRATED: 'Please integrate slack to enable this field',
  ERRORS: {
    SOMETHING_WENT_WRONG: ' Something went wrong. Please try again!',
  },
};

export const FIEDL_MAPPING_PAGE = {
  DEFAULT: 'Saved successfully',
  FIELD_SAVE: 'Field saved successfully',
  FIELD_DELETE: 'Field deleted successfully',
  FIELD_STATUS_TOGGLE: 'Field status updated successfully',
};

export const PERMISSION_MESSAGE = {
  NOT_AUTHORIZED: 'You are not authorized',
};
